import React from "react";
import {
  Row,
  Col,
  Flex,
  Statistic,
  Table,
  Tag,
  Typography,
  Card,
  Space,
  Button,
  Grid, // <- added
} from "antd";
import { useNavigate } from "react-router-dom"; // <- added
import { HomeOutlined, CaretLeftOutlined } from "@ant-design/icons"; // <- added
const { Title, Text } = Typography;

// ── Component ──────────────────────────────────────────
const Dashboard = () => {
  const navigate = useNavigate(); // <- added
  const screens = Grid.useBreakpoint(); // <- added
  // screens.sm è true quando la viewport è >= sm; regola la logica come preferisci
  const cardWidth = screens.md ? "50vw" : "100vw"; // usa "100%" su schermi >= sm, altrimenti 10vw

  const categorie = ["Acqua", "te", "succo", "spritz"];
  return (
    <Space direction="vertical" size={24} style={{ width: "100%" }}>
      {/* ── Hero banner with orange background ── */}
      <div
        style={{
          background: "white",
          height: "100vh",
          //display: "flex",
        }}
      >
        <div
          style={{
            background: "linear-gradient(135deg, #f9b27fff, #ff8c00)",
            height: "100px",
            maxHeight: "100px",

            display: "flex",
            alignItems: "center",
            justifyContent: "center",

            boxShadow: "0 4px 20px rgba(255, 106, 0, 0.3)",

            position: "relative", // <- added so the home button can be positioned left
          }}
        >
          <Button
            type="text"
            onClick={() => navigate("/categorie")}
            icon={<CaretLeftOutlined />}
            aria-label="Home"
            style={{
              position: "absolute",
              left: 16,
              top: "50%",
              transform: "translateY(-50%)",
              color: "#fff",
              fontSize: 20,
            }}
          >
            {" "}
            Back{" "}
          </Button>
          {/* Left: title */}
          <div style={{ alignItems: "center", justifyContent: "center" }}>
            <Title
              level={1}
              style={{
                color: "#fff",
                //margin: 0,
                letterSpacing: "-0.4px",
              }}
            >
              Logopedista
            </Title>
          </div>
        </div>

        <Card
          style={{ width: cardWidth, alignItems: "center", margin: "0 auto" }}
        >
          {categorie.map((cat) => (
            <Card
              type="inner"
              key={cat}
              title={cat}
              style={{ marginBottom: "16px" }}
              extra={<a href="#">Guarda</a>}
            >
              Inner Card content da definire
            </Card>
          ))}
        </Card>
      </div>
    </Space>
  );
};

export default Dashboard;
